import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { useTheme } from '@mui/material/styles';
import { useMediaQuery, Box, Container, Toolbar } from '@mui/material';

// project import
import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import HorizontalBar from './Drawer/HorizontalBar';
import Breadcrumbs from 'layout/mantis/components/@extended/Breadcrumbs';
import useAuthContext from 'context/useAuthContext';

import navigation from './Menu';
import useConfigContext from 'context/useConfigContext';
import { openDrawer } from 'layout/mantis/store/reducers/menu';

// types
import { RootStateProps } from 'layout/mantis/types/RootType';
import { LAYOUT_CONST } from 'types/ConfigType';
import menuItem from './Menu';
import { NavItemType } from '../../mantis/types/MenuType';

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
	const theme = useTheme();
	const matchDownLG = useMediaQuery(theme.breakpoints.down('xl'));
	const downLG = useMediaQuery(theme.breakpoints.down('lg'));

	const { container, miniDrawer, menuOrientation } = useConfigContext();
	const dispatch = useDispatch();

	const isHorizontal = menuOrientation === LAYOUT_CONST.HORIZONTAL_LAYOUT && !downLG;

	const menu = useSelector((state: RootStateProps) => state.menu);
	const { drawerOpen } = menu;

	// drawer toggler
	const [open, setOpen] = useState(!miniDrawer || drawerOpen);
	const handleDrawerToggle = () => {
		setOpen(!open);
		dispatch(openDrawer({ drawerOpen: !open }));
	};

	// set media wise responsive drawer
	useEffect(() => {
		if (!miniDrawer) {
			setOpen(!matchDownLG);
			dispatch(openDrawer({ drawerOpen: !matchDownLG }));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [matchDownLG]);

	useEffect(() => {
		if (open !== drawerOpen) setOpen(drawerOpen);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [drawerOpen]);

	const { items } = navigation()

	return (
		<Box sx={ { display: 'flex', width: '100%' } }>
			<Header open={ open } handleDrawerToggle={ handleDrawerToggle } />
			{ !isHorizontal ? <Drawer open={ open } handleDrawerToggle={ handleDrawerToggle } /> : <HorizontalBar /> }

			<Box component='main' sx={ { width: 'calc(100% - 260px)', flexGrow: 1, p: { xs: 2, sm: 3 } } }>
				<Toolbar sx={ { mt: isHorizontal ? 8 : 'inherit' } } />
				<Container
					maxWidth={ container ? 'xl' : false }
					sx={ {
						...(container && { px: { xs: 0, sm: 2 } }),
						position: 'relative',
						minHeight: 'calc(100vh - 110px)',
						display: 'flex',
						flexDirection: 'column'
					} }
				>
					<Breadcrumbs title navigation={ { items } } card={ false } divider={ false } />
					<Outlet />
					<Footer />
				</Container>
			</Box>
		</Box>
	);
};

export default MainLayout;
